export default {
    environment: 'LOCALHOST',
};



// WEBPACK FOOTER //
// ./src/config/applicationConfiguration.js